import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router/src/router_state';
import { Store } from '@ngrx/store';
import { IState } from '../shared/models/state';
import { Actions } from '@ngrx/effects';
import { CrazyCallConfigService } from '../lead-generation/shared/services/crazycall-config.service';
import { LanguageService } from '../shared/services/language.service';
import { initialConfig } from '../lead-generation/shared/domain/initialConfig';
import {
  CREATE_DEFAULT_CONFIGURATION_FAILURE,
  CREATE_DEFAULT_CONFIGURATION_SUCCESS,
  CreateDefaultConfigurationAction,
  CreateDefaultConfigurationFailureAction,
  CreateDefaultConfigurationSuccessAction
} from '../lead-generation/projects/projects.action';
import { getActiveProjectSelector } from '../lead-generation/projects/projects.reducer';
import { map, switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { CURRENT_STATE_CHANGED, GoToNextStateAction } from './first-steps.actions';

@Injectable()
export class FirstStepsLeadGenerationResolve implements Resolve<any> {
  constructor(
    private store: Store<IState>,
    private action$: Actions,
    private crazyCallConfigService: CrazyCallConfigService,
    private languageService: LanguageService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.select(getActiveProjectSelector).pipe(
      take(1),
      switchMap(project => {
        if (project) {
          return of(project);
        } else {
          return this.createDefaultConfiguration();
        }
      })
    );
  }

  private createDefaultConfiguration() {
    const config = initialConfig(this.crazyCallConfigService.appId, this.languageService.getCookieLanguage() || 'en');
    this.store.dispatch(new CreateDefaultConfigurationAction(config));

    return this.action$.ofType(CREATE_DEFAULT_CONFIGURATION_SUCCESS, CREATE_DEFAULT_CONFIGURATION_FAILURE).pipe(
      take(1),
      map((action: CreateDefaultConfigurationSuccessAction | CreateDefaultConfigurationFailureAction) => {
        // User must be able to continue registration process, even if LeadGeneration/WebCall cannot be configured
        if (action.type === CREATE_DEFAULT_CONFIGURATION_FAILURE) {
          this.store.dispatch(new GoToNextStateAction());
          return this.action$.ofType(CURRENT_STATE_CHANGED).take(1);
        }
        return of(action);
      })
    );
  }
}
